import { firestore } from '@/firebaseConfig'
import MapBundle from '../model/MapBundle';
import Publisher from "../model/Publisher";

export default class PublisherService {
    loadPublishers() {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Publisher(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadPublisher(publisherId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).get().then((doc) => {
                if (doc.exists) {
                    resolve(new Publisher(doc.data()));
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadPublishersForBundle(bundleId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").where("bundleIds." + bundleId, "==", true).get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Publisher(doc.data()));
                });

                resolve(result);
            }).catch((error) => { 
                reject(error);
            })
        });

        return promise;
    }

    loadPublishersForUser(userId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").where("users", "array-contains", userId).get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Publisher(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadPublisherLexical(publisherId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("analytics").doc("basic").collection("lexical").where("publisherId", "==", publisherId).get().then((querySnapshot) => {
                const result = {};

                querySnapshot.forEach((doc) => {
                    result[doc.id] = doc.data();
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadPublisherMapBundles(publisherId) {
        return new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("bundles").get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new MapBundle(doc.data()))
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    saveBundleForPublisher(publisherId, mapBundle) {
        return new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("bundles").doc(mapBundle.id).set(mapBundle.toJSON()).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }
}